import React, { useEffect, useState } from "react";

// Holographic bottom-centre clock. `accent` colours it (project colour); null = white.
// `left` / `right` render optional buttons on either side of the clock.
export default function ClockDock({ accent = null, left = null, right = null }) {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const p2 = (x) => String(x).padStart(2, "0");
  const time = `${p2(now.getHours())}:${p2(now.getMinutes())}`;
  const date = `${p2(now.getDate())}.${p2(now.getMonth() + 1)}.${now.getFullYear()}`;
  const glow = accent || "#FFFFFF";

  return (
    <div data-testid="clock-dock" className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 flex items-end gap-3 sm:gap-4">
      {left}
      <div
        data-testid="live-clock"
        className="holo-clock rounded-2xl px-5 sm:px-7 py-2 text-center select-none"
        style={{ "--holo": glow, borderColor: `${glow}66`, boxShadow: `0 0 22px ${glow}44, inset 0 0 18px ${glow}22`, color: glow }}
      >
        <div data-testid="clock-time" className="holo-time font-heading font-bold text-3xl sm:text-4xl leading-none tabular-nums tracking-[0.15em]">
          {time}
        </div>
        <div data-testid="clock-date" className="holo-date text-[10px] sm:text-xs tracking-[0.3em] mt-1 opacity-80 tabular-nums">
          {date}
        </div>
      </div>
      {right}
    </div>
  );
}
